import { useEffect } from 'react';

type ToastProps = {
  open: boolean;
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
};

const Toast = ({
  open,
  message,
  type = 'success',
  onClose,
}: ToastProps) => {
  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  const bgColor =
    type === 'success'
      ? 'bg-green-600'
      : type === 'error'
      ? 'bg-red-600'
      : type === 'warning'
      ? 'bg-yellow-500'
      : 'bg-blue-600';

  return (
    <div className="fixed top-5 right-5 z-[9999]">
      <div
        className={`${bgColor} min-w-[320px] rounded-lg px-5 py-3 text-white shadow-xl`}
      >
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">
            {message}
          </span>

          <button
            onClick={onClose}
            className="ml-4 text-lg font-bold text-white hover:opacity-80"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;